/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
`
export default class EmoticonIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" css={Color}>
        <g id="그룹_5377" data-name="그룹 5377" transform="translate(-4570 -1225)">
          <circle id="타원_496" data-name="타원 496" cx="12" cy="12" r="12" transform="translate(4570 1225)" fill="none"/>
          <path className="line" id="패스_5156" data-name="패스 5156" d="M12.38,24.009A11.869,11.869,0,1,1,24.247,12.138v0A11.883,11.883,0,0,1,12.38,24.009Zm0-21.745a9.876,9.876,0,1,0,9.875,9.877h0A9.887,9.887,0,0,0,12.38,2.264Z" transform="translate(4569.661 1224.819)" fill="#acacac"/>
          <circle className="line" id="타원_497" data-name="타원 497" cx="1.611" cy="1.611" r="1.611" transform="translate(4576.428 1231.842)" fill="#acacac"/>
          <circle className="line" id="타원_498" data-name="타원 498" cx="1.611" cy="1.611" r="1.611" transform="translate(4584.558 1231.842)" fill="#acacac"/>
          <path className="line" id="패스_5157" data-name="패스 5157" d="M20.9,43.9a7.61,7.61,0,0,1-5.739-2.617,9.705,9.705,0,0,1-1.848-2.944,1.008,1.008,0,0,1,1.9-.665c.015.042,1.589,4.212,5.682,4.212,4.224,0,5.728-4.029,5.789-4.2a1.008,1.008,0,1,1,1.918.622c-.007.021-.014.041-.022.062a9.352,9.352,0,0,1-1.957,3.067A7.757,7.757,0,0,1,20.9,43.9Z" transform="translate(4561.155 1200.339)" fill="#acacac"/>
        </g>
      </svg>
    )
  }
}
